import { VehicleExportDto } from '../../../../shared/types';

export type PartType = 'Seat Covers' | 'Cargo Liner' | 'Dash Cover';

export function buildPartsListHtml(rows: VehicleExportDto[], partType: PartType): string {
  const isCargo = partType === 'Cargo Liner';
  const isDash = partType === 'Dash Cover';
  const isSimpleLayout = isCargo || isDash;

  const grouped = rows.reduce<Record<string, VehicleExportDto[]>>((acc, row) => {
    const key = row.Make;
    if (!acc[key]) acc[key] = [];
    acc[key].push(row);
    return acc;
  }, {});

  const makesSorted = Object.keys(grouped).sort();

  const buildTable = (makeRows: VehicleExportDto[]) => {
    if (isSimpleLayout) {
      const headers = '<th>Model</th><th>Submodel</th><th>Type</th><th>Start Year</th><th>End Year</th><th>Number of Doors</th><th>Fitment Notes</th><th>Price</th><th>Part Number</th>';
      const bodyRows = makeRows.map(r => `<tr>
          <td>${r.Model}</td>
          <td>${r.SubModel || ''}</td>
          <td>${r.BodyTypeName || ''}</td>
          <td>${r.FromYear}</td>
          <td>${r.ToYear}</td>
          <td>${r.NumberOfDoors || ''}</td>
          <td>${r.FitmentNotes || ''}</td>
          <td>${r.Price}</td>
          <td>${r.PartNumber}</td>
        </tr>`).join('');
      return `<table><thead><tr>${headers}</tr></thead><tbody>${bodyRows}</tbody></table>`;
    }

    // Drive Type / Transmission columns are dropped entirely for a make's table
    // when none of its rows have a value for that field.
    const hasDriveType = makeRows.some(r => r.DriveTypes && r.DriveTypes.length > 0);
    const hasTransmission = makeRows.some(r => r.TransmissionTypes && r.TransmissionTypes.length > 0);

    const headers = [
      '<th>Model</th>',
      '<th>Submodel</th>',
      '<th>Type</th>',
      '<th>Start Year</th>',
      '<th>End Year</th>',
      '<th>Seat Row</th>',
      '<th>Number of Doors</th>',
      hasDriveType ? '<th>Drive Type</th>' : '',
      hasTransmission ? '<th>Transmission</th>' : '',
      '<th>Seat Type</th>',
      '<th>Fitment Notes</th>',
      '<th>Price</th>',
      '<th>Part Number</th>',
    ].join('');

    const bodyRows = makeRows.map(r => `<tr>${[
      `<td>${r.Model}</td>`,
      `<td>${r.SubModel || ''}</td>`,
      `<td>${r.BodyTypeName || ''}</td>`,
      `<td>${r.FromYear}</td>`,
      `<td>${r.ToYear}</td>`,
      `<td>${r.SeatRow}</td>`,
      `<td>${r.NumberOfDoors || ''}</td>`,
      hasDriveType ? `<td>${r.DriveTypes.join(', ')}</td>` : '',
      hasTransmission ? `<td>${r.TransmissionTypes.join(', ')}</td>` : '',
      `<td>${r.SeatType}</td>`,
      `<td>${r.FitmentNotes || ''}</td>`,
      `<td>${r.Price}</td>`,
      `<td>${r.PartNumber}</td>`,
    ].join('')}</tr>`).join('');

    return `<table><thead><tr>${headers}</tr></thead><tbody>${bodyRows}</tbody></table>`;
  };

  const title = isCargo ? 'CalTrend Cargo Liner Parts List' : isDash ? 'CalTrend Dash Cover Parts List' : 'CalTrend Parts List';

  return `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8"/>
  <title>${title}</title>
  <style>
    body { font-family: Arial, sans-serif; font-size: 10px; margin: 20px; }
    h1 { font-size: 15px; margin-bottom: 4px; }
    h2 { font-size: 12px; margin: 16px 0 4px; background: #ddd; padding: 3px 6px; }
    table { border-collapse: collapse; width: 100%; margin-bottom: 12px; }
    th, td { border: 1px solid #aaa; padding: 2px 5px; text-align: left; white-space: nowrap; }
    th { background: #eee; font-weight: bold; }
    .print-btn { margin-bottom: 12px; padding: 6px 14px; cursor: pointer; font-size: 13px; }
    @media print { .print-btn { display: none; } }
  </style>
</head>
<body>
  <button class="print-btn" onclick="window.print()">Print</button>
  <h1>${title}</h1>
  ${makesSorted.map(make => `<h2>${make}</h2>${buildTable(grouped[make])}`).join('')}
</body>
</html>`;
}
